export default function TopAgency() {
  return (
    <section id="top-agencies" className="py-20 bg-gradient-to-br from-teal-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
            #1 RANKED
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Houston Health Insurance Experts
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            The premier choice for self-employed professionals and higher earners seeking personalized private health insurance solutions
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-teal-500">
          <div className="grid md:grid-cols-2 gap-0">
            <div className="relative h-80 md:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/1882e83e07497b28c01c93d4aedb78f3.jpg"
                alt="Houston Health Insurance Experts"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-6 left-6 bg-teal-500 text-white px-4 py-2 rounded-lg font-bold text-lg shadow-lg">
                ⭐ 5.0 Rating
              </div>
            </div>

            <div className="p-8 md:p-12">
              <div className="mb-6">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">Why We're #1</h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Self-Employed Specialists:</strong>
                      <p className="text-gray-600 text-sm mt-1">Expert guidance for entrepreneurs, freelancers, and independent contractors navigating complex insurance options</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Higher Earner Solutions:</strong>
                      <p className="text-gray-600 text-sm mt-1">Reduce premium costs without sacrificing coverage quality through strategic plan selection</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Private Insurance Focus:</strong>
                      <p className="text-gray-600 text-sm mt-1">Personalized individual and family plans, plus dental and vision coverage tailored to your needs</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-6 mt-6">
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <div className="flex items-center space-x-2 text-gray-700 mb-2">
                      <i className="ri-map-pin-line text-teal-500"></i>
                      <span className="text-sm font-medium">Location</span>
                    </div>
                    <p className="text-sm text-gray-600">11104 W Airport Blvd R D O<br />Stafford, TX 77477</p>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2 text-gray-700 mb-2">
                      <i className="ri-phone-line text-teal-500"></i>
                      <span className="text-sm font-medium">Phone</span>
                    </div>
                    <a href="tel:2812062619" className="text-sm text-teal-500 font-semibold hover:text-teal-600 cursor-pointer">
                      (281) 206-2619
                    </a>
                  </div>
                </div>

                <a href="tel:2812062619" className="block w-full bg-teal-500 text-white text-center px-6 py-3 rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                  Schedule Your Free Consultation
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
